export const en = {
    'empty-words': 'No negative keywords',
    'empty-words-content': 'Negative words not found. To refine a keyword, add the negative keywords manually.',
    'error-words': 'Unable to load the negative keywords',
    'refine-note': 'Select the negative keywords to refine the keyword.',
    'show-more': 'Show more',
    'shows-text': 'Monthly impression forecast — {showsCount}',
    'word-shows': {
        one: '{count} impression',
        some: '{count} impressions',
        many: '{count} impressions',
        none: '{count} impressions'
    }
};
